/**
 * Typed analytics utility for gtag events.
 * No `any` — strict typing for all event payloads.
 */

export interface AnalyticsPayload extends Record<string, string | number | boolean | undefined | null> {}

export interface GtagWindow extends Window {
  gtag?: (
    command: 'event',
    eventName: string,
    payload: AnalyticsPayload
  ) => void;
}

export function trackEvent(
  eventName: string,
  payload: AnalyticsPayload = {}
): void {
  if (typeof window !== 'undefined') {
    const win = window as unknown as GtagWindow;
    if (win.gtag) {
      win.gtag('event', eventName, payload);
    }
  }
  // eslint-disable-next-line no-console
  console.log('[Analytics]', eventName, payload);
}
